export const PRODUCT_TYPES = {
  FLIGHT: {
    LOWER_CASE: "flight",
    UPPER_CASE: "FLIGHT",
    SENTENCE_CASE: "Flight",
  },
  BUS: {
    LOWER_CASE: "bus",
    UPPER_CASE: "BUS",
    SENTENCE_CASE: "Bus",
  },
  HOTEL: {
    LOWER_CASE: "hotel",
    UPPER_CASE: "HOTEL",
    SENTENCE_CASE: "Hotel",
  },
  CAR: {
    LOWER_CASE: "car",
    UPPER_CASE: "CAR",
    SENTENCE_CASE: "Car",
  },
  FERRY: {
    LOWER_CASE: "ferry",
    UPPER_CASE: "FERRY",
    SENTENCE_CASE: "Ferry",
  },
  EMAIL: {
    LOWER_CASE: "email",
    UPPER_CASE: "EMAIL",
    SENTENCE_CASE: "Email",
  },
};
